/**
 * Rótulo do favorecido dentro da regra de repasse (card 86ajtj0qf).
 *
 * Recebe o registro pivot (onlending_beneficiaries) já com a relação
 * `beneficiary` carregada. O backend devolve também favorecidos excluídos
 * (relacionamento withTrashed) para que a tela consiga identificar e remover
 * quem saiu do cadastro — antes a linha simplesmente desaparecia.
 */

const CLINIC_PROFESSIONAL = 'CLINIC_PROFESSIONAL'

const DOCTOR_ROLES = {
  DOCTOR: 'Médico',
  DOCTOR_ANESTHESTIST: 'Anestesista',
  DOCTOR_ANESTHETIST: 'Anestesista',
  DOCTOR_MANAGER: 'Médico Gestor'
}

const SIMPLE_ROLES = {
  SECRETARY: 'Secretária',
  NURSE: 'Enfermeiro',
  TECHNICIAN: 'Técnico',
  TECHNOLOGIST: 'Tecnólogo',
  MANAGER: 'Gestor'
}

/** O favorecido foi excluído do cadastro (soft delete). */
export function isDeletedBeneficiary(onlendingBeneficiary) {
  return Boolean(onlendingBeneficiary?.beneficiary?.deleted_at)
}

/** Quantos favorecidos da regra estão excluídos. */
export function countDeletedBeneficiaries(onlendingBeneficiaries) {
  if (!Array.isArray(onlendingBeneficiaries)) return 0
  return onlendingBeneficiaries.filter(isDeletedBeneficiary).length
}

function doctorPrefix(person) {
  return person?.gender === 'F' ? 'Dra. ' : 'Dr. '
}

export function getBeneficiaryLabel(onlendingBeneficiary) {
  const beneficiary = onlendingBeneficiary?.beneficiary

  if (!beneficiary) return 'Favorecido não identificado'

  const name = beneficiary.name || 'Favorecido sem nome'
  const person = beneficiary.person
  const role = person?.clinic_person?.role?.replace('_INVITED', '')

  if (beneficiary.type !== CLINIC_PROFESSIONAL || !person?.clinic_person) {
    return `Externo - ${name}`
  }

  if (DOCTOR_ROLES[role]) {
    return `${DOCTOR_ROLES[role]} - ${doctorPrefix(person)}${name}`
  }

  if (SIMPLE_ROLES[role]) {
    return `${SIMPLE_ROLES[role]} - ${name}`
  }

  return `${person.clinic_person.role} - ${name}`
}
